// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShipClass_wrapper_2MqaD"};